export default __webpack_public_path__ + "static/media/simple_ira_light.647d23ad.png";